import React from 'react';
import Select, { components, createFilter } from 'react-select';
import { classNames } from "../../common/util/util-helpers";
import { getCustomStyles } from "./field-themes";

const CustomOption = props => {
    return <components.Option {...props} />;
};

export default function FieldSelectSearch({item = {}, onChange, values}) {
    if (!item.props) {
        item.props = {}
    }

    const pairs = !!values ? values : {};

    values = Object.keys(pairs);

    if (!item.props.omitSort) {
        values = values.sort((a, b) => {
            return (pairs[a] == pairs[b]) ? 0 : ((pairs[a] > pairs[b]) ? 1 : -1);
        });
    }

    if (!!item.props.valueSort) {
        values = Object.keys(pairs).sort((a, b) => {
            return pairs[a] - pairs[b]
        });
    }

    if (!!item.props.reverseValueSort || item.props.name === "Year") {
        values = Object.keys(pairs).sort((a, b) => {
            return pairs[b] - pairs[a]
        });
    }

    if (!!item.props.keySort) {
        values = values.sort((a, b) => a - b);
    }

    if (!!item.props.reverseKeySort) {
        values = values.sort((a, b) => b - a);
    }

    values = values.map((key, i) => ({value: key, label: pairs[key]}));
    const filterOnInputChange = (newValue) => {
        const newValueToLowerCase = newValue.toLowerCase();
        values.sort(function(a, b) {
            return a.label.toLowerCase().indexOf(newValueToLowerCase) < b.label.toLowerCase().indexOf(newValueToLowerCase) ? -1 : 1;
        });
    }

    const filterConfig = {
        ignoreCase: true,
        ignoreAccents: true,
        trim: true,
        matchFrom: 'any',
    };

    return (
        <React.Fragment>
            <Select
                ref={item.props.innerRef}
                placeholder={item.props.placeholder ? item.props.placeholder : "Select..."}
                isMulti={item.props.isMulti}
                onChange={(selectedOption) => {
                    onChange(item.name, selectedOption ? (!item.props.options ? selectedOption.value : selectedOption) : "");
                }}
                className={
                    classNames(item.props.className ?? "select-css-search p-0 form-control",
                        item.props.addClass
                    )
                }
                styles={getCustomStyles()}
                value={!item.props.options ? (item.value ? {
                    value: item.value,
                    label: pairs[item.value]
                } : null) : item.value}
                isClearable={!!item.props.all}
                isSearchable={true}
                isDisabled={item.disabled}
                name={item.props.name}
                options={item.props.options ? item.props.options : values}
                filterOption={createFilter(filterConfig)}
                components={{Option: CustomOption}}
                autoFocus={item.props.autoFocus}
                onInputChange={(newValue) => {
                    if (item.props.onInputChangeProp) {
                        filterOnInputChange(newValue)
                    }
                }}
                menuPlacement={item.props.menuPlacement}
                menuPortalTarget={item.props.hasPortal ? document.body : null}
            />
        </React.Fragment>
    );

}
